import { Edit } from 'react-admin';
import { StoreForm } from './Store.Form';

export const StoreEdit = () => {
    return (
        <Edit>
            <StoreForm />
        </Edit>
    );
};
